import { render, staticRenderFns } from "./Icon8.vue?vue&type=template&id=24d270b2&"
import script from "./Icon8.vue?vue&type=script&lang=js&"
export * from "./Icon8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports